import React, { useState } from 'react'
import { PiEyeThin, PiHeartStraightThin, PiShareNetworkThin } from 'react-icons/pi'
import ProductQuickView from './ProductQuickView'
import Modal from './commons/Modal';
import { CgClose } from 'react-icons/cg';

export const ProductCardAction = ({product}) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <Modal isOpen={isOpen} onClose={() => setIsOpen(false)}>
        <div className='flex absolute right-0 top-0 m-4'><button className='rounded-full border p-4' onClick={()=>setIsOpen(false)}><CgClose/></button></div>
        <ProductQuickView product={product}/>
      </Modal>

      <div className='flex flex-col  absolute right-0 top-0 h-full p-2 items-center justify-start z-50 gap-2 opacity-0 group-hover/card:opacity-100 transition-opacity duration-300'>

      {product._id!="67c9c9c0b29d44f2f3977f74" &&   <button className='rounded-full w-[35px] h-[35px] bg-[--color-button-1] flex items-center justify-center hover:bg-[--color-button-3] transition-all duration-200' onClick={()=>setIsOpen(true)}><PiEyeThin className='text-xl' /></button>}
        <button className='rounded-full w-[35px] h-[35px] bg-[--color-button-1]  flex items-center justify-center hover:bg-[--color-button-3] transition-all duration-200'><PiShareNetworkThin className='text-xl' /></button>
        <button className='rounded-full w-[35px] h-[35px] bg-[--color-button-1]  flex items-center justify-center hover:bg-[--color-button-3] transition-all duration-200'><PiHeartStraightThin className='text-xl' /></button>
      </div>
    </>
  )
}
